module.exports = __webpack_public_path__ + "img/user_friend_step2.7f685f16.svg";